{
  "name": "@srgssr/srgletterbox-web",
  "version": "3.38.0",
  "description": "",
  "main": "dist/letterbox.js",
  "targets": {
    "github-page": {
      "publicUrl": "./",
      "source": [
        "index.html",
        "player-bar.html"
      ],
      "isLibrary": false,
      "outputFormat": "esmodule"
    },
    "main": {
      "source": "src/SRGLetterbox.js"
    }
  },
  "publishConfig": {
    "registry": "https://npm.pkg.github.com/",
    "access": "public"
  },
  "files": [
    "dist/*",
    "docs/*"
  ],
  "browserslist": [
    "Edge >= 16",
    "Firefox >= 52",
    "Chrome >= 57",
    "Safari >= 10.1",
    "ios_saf >= 9",
    "FirefoxAndroid >= 65",
    "ChromeAndroid >= 76",
    "Opera >= 44"
  ],
  "author": "",
  "license": "ISC",
  "bugs": {
    "url": "https://github.com/SRGSSR/srgletterbox-web/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/SRGSSR/srgletterbox-web.git"
  },
  "homepage": "https://srgssr.github.io/srgletterbox-web",
  "scripts": {
    "build": "npm run generate:build_info && npm run webpack && npm run generate:doc",
    "clean": "rimraf dist",
    "dev": "npm run parcel:dev",
    "dev:doc": "npm run generate:doc && npm run parcel:dev:doc",
    "dev:https": "npm run parcel:dev:https",
    "deploy": "gh-pages -d dist",
    "eslint": "eslint --ext .js ./src",
    "eslint:fix": "eslint --fix --ext .js ./src",
    "eslint:silent": "eslint --ext .js ./;exit 0",
    "font:install": "cd fonts && npm install && npm rebuild node-sass",
    "generate:build_info": "cross-env echo {\\\"date\\\":\\\"$CODEBUILD_START_TIME\\\", \\\"commit\\\":\\\"$CODEBUILD_RESOLVED_SOURCE_VERSION\\\" , \\\"runner\\\":\\\"$CODEBUILD_BUILD_ID\\\", \\\"initiator\\\":\\\"$CODEBUILD_INITIATOR\\\"  } > generated/build.json",
    "generate:doc": "jsdoc -c jsdoc.json && cp -r docs/ dist/docs",
    "generate:fonts": "npm run font:install && cd fonts && ./node_modules/grunt/bin/grunt && cd .. && npm run stylelint:font",
    "webpack": "webpack",
    "parcel:dev": "parcel *.html",
    "parcel:dev:doc": "parcel dist/docs/index.html",
    "parcel:dev:https": "parcel index.html --https",
    "parcel:github:page": "npm run predeploy",
    "predeploy": "npm run clean && npm run generate:build_info && npx parcel build --target github-page",
    "prepublishOnly": "npm run build",
    "release:ci": "semantic-release",
    "test": "jest --verbose",
    "test:coverage": "jest --collectCoverage",
    "test:file:coverage:watch": "jest $npm_config_file_name --coverage --collectCoverageFrom=**/$npm_config_file_name* --watch",
    "test:watch": "jest --watch --verbose",
    "stylelint": "stylelint src/**/*.scss",
    "stylelint:fix": "stylelint src/**/*.scss --fix",
    "stylelint:font": "stylelint src/mediaPlayer/scss/_icons.scss --fix",
    "version": ""
  },
  "dependencies": {
    "@videojs/http-streaming": "3.2.0",
    "bowser": "^2.9.0",
    "video.js": "7.16.0",
    "videojs-contrib-dash": "https://github.com/SRGSSR/videojs-contrib-dash/raw/fix/audio-track-kind/videojs-contrib-dash-5.1.1.tgz",
    "videojs-contrib-eme": "3.10.1",
    "videojs-contrib-quality-levels": "^2.0.9",
    "videojs-vr": "^1.5.0"
  },
  "devDependencies": {
    "@babel/cli": "^7.21.0",
    "@babel/core": "^7.21.4",
    "@babel/plugin-transform-runtime": "^7.21.4",
    "@babel/preset-env": "^7.21.4",
    "@commitlint/cli": "^8.3.5",
    "@commitlint/config-conventional": "^8.3.4",
    "@parcel/babel-preset-env": "^2.8.3",
    "@parcel/transformer-sass": "^2.8.3",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "babel-loader": "^8.1.0",
    "buffer": "^5.7.1",
    "clean-webpack-plugin": "^3.0.0",
    "cross-env": "^6.0.3",
    "css-loader": "^3.4.2",
    "eslint": "^5.14.0",
    "eslint-config-airbnb-base": "^13.2.0",
    "eslint-plugin-i18n-text-localize": "^1.1.1",
    "eslint-plugin-import": "^2.18.0",
    "eslint-plugin-jest": "^22.7.2",
    "file-loader": "^5.0.2",
    "gh-pages": "^2.0.1",
    "husky": "^4.2.3",
    "jest": "^24.4.0",
    "jsdoc": "^3.6.3",
    "mini-css-extract-plugin": "^0.9.0",
    "node-fetch": "^2.6.1",
    "optimize-css-assets-webpack-plugin": "^5.0.3",
    "parcel": "^2.8.3",
    "sass": "^1.22.4",
    "sass-loader": "^8.0.2",
    "semantic-release": "^19.0.5",
    "semver": "^6.3.0",
    "stream-browserify": "^3.0.0",
    "stylelint": "^11.1.1",
    "stylelint-config-rational-order": "^0.1.2",
    "stylelint-order": "^3.1.1",
    "terser-webpack-plugin": "^2.3.5",
    "webpack": "^4.41.6",
    "webpack-cli": "^3.3.11"
  },
  "overrides": {
    "videojs-contrib-eme": {
      "jsdoc": "^3.6.10"
    }
  },
  "husky": {
    "hooks": {
      "commit-msg": "commitlint -E HUSKY_GIT_PARAMS",
      "pre-commit": "npm run eslint && npm run stylelint",
      "pre-push": "npm test"
    }
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  },
  "release": {
    "branches": [
      "master"
    ],
    "prepare": [
      [
        "@semantic-release/changelog",
        {
          "changelogFile": "docs/CHANGELOG.md"
        }
      ],
      "@semantic-release/npm",
      [
        "@semantic-release/git",
        {
          "assets": [
            "docs/",
            "package.json",
            "package-lock.json",
            "README.md"
          ],
          "message": "chore(release): ${nextRelease.version} [skip ci]\n\n${nextRelease.notes}"
        }
      ]
    ]
  }
}
